<button
  class="flex cursor-pointer items-center rounded-full py-1 pl-2 pr-3 text-sm transition-colors hover:bg-slate-300"
  type="button"
  qaroniClickStopPropagation
  [ngClass]="ngClassColor"
  cdkOverlayOrigin
  #trigger="cdkOverlayOrigin"
  (click)="onClick()"
  [matTooltip]="tooltipText">
  <mat-icon
    [fontIcon]="icon"
    class="qaroni-mat-icon-18 material-symbols-outlined" />

  @if (files()?.length) {
    <span class="text-base font-medium text-black">
      {{ files()?.length }}
    </span>
  }
</button>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isOpen && files()?.length > 0"
  (overlayOutsideClick)="isOpen = false"
  (detach)="isOpen = false">
  <div
    class="z-50 mt-2 min-w-56 rounded-lg border border-slate-200 bg-white p-2 shadow-xl">
    <ul class="flex flex-col gap-1">
      @for (file of files(); track file.fileId) {
        <li
          role="button"
          tabindex="0"
          (click)="onFilePreview(file)"
          (keydown.enter)="onFilePreview(file)"
          (keydown.space)="onFilePreview(file)"
          i18n-matTooltip
          class="flex cursor-pointer items-center gap-2 rounded-md px-3 py-2 text-sm text-slate-700 transition-colors hover:bg-slate-100">
          <mat-icon
            fontIcon="visibility"
            class="qaroni-mat-icon-18 material-symbols-outlined text-accent-50" />
          <span>Mostrar {{ file.file | fileNameTruncate }}</span>
        </li>
      }
    </ul>
  </div>
</ng-template>
